import React, {Component} from 'react';
import { pluralize } from '../../../lib/Helpers';
import {observer, inject} from 'mobx-react';

@inject('mapStore')
class Trail extends Component {
    render() {
        return <div className="detail-content">

            <div className="image"><img src="https://lorempixel.com/600/600/" alt="" /></div>

            <div className="scroll-pane">

                <h3 className="title">
                    {this.props.name}
                </h3>

                <div className="trail-stops">
                    {this.props.number_stops} {pluralize('stop', this.props.number_stops)} across {this.props.number_floors} {pluralize('floor', this.props.number_floors)}
                </div>

                <div className="description">
                  {this.props.description}
                </div>

                <div className="trail-link">
                    <a href="http://www.vam.ac.uk">Begin trail</a>
                </div>

            </div>

        </div>
    }
}

export default Trail;
